import { Component, Input } from '@angular/core';
import { IvyChargepoint } from '../../../../api/chargepoints-api.service';
import { CopiableInfoComponent } from '../../../../elements/copiable-info/copiable-info.component';

@Component({
  selector: 'app-ivy-vendor-info',
  templateUrl: './ivy-vendor-info.component.html',
  styleUrls: ['./ivy-vendor-info.component.scss'],
  imports: [CopiableInfoComponent]
})
export class IvyVendorInfoComponent {

  @Input() chargepoint?: IvyChargepoint;

}
